export default function parseAspectRatio(aspect: string): number | null {
  const [width, height] = aspect.split(':').map(Number);
  if (!Number.isFinite(width) || !Number.isFinite(height) || height === 0) {
    return null;
  }
  return width / height;
}
